<template>
    <a @click="emitSearch" data-action="reload" ref="loadIcon"/>
</template>

<script>
    export default {
        name: "block-target",
        computed: {
            $blockTarget: function () {
                let $target = $(this.$el)
                return $target.closest('.block-target');
            },
        },
        methods: {
            block: function () {
                this.$blockTarget.block({
                    message: '<i class="icon-spinner2 spinner"></i>',
                    overlayCSS: {
                        backgroundColor: '#fff',
                        opacity: 0.8,
                        cursor: 'wait',
                        'box-shadow': '0 0 0 1px #ddd'
                    },
                    css: {
                        border: 0,
                        padding: 0,
                        backgroundColor: 'none'
                    }
                });
            },
            unblock: function() {
                this.$blockTarget.unblock()
            },
            emitSearch: function() {
                this.$emit('search')
            }
        },
    }
</script>

<style scoped>

</style>
